import httpClient from "./httpClient";

export function generateIdempotencyKey(prefix = "req") {
  const random = typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  return `${prefix}-${random}`;
}

export function extractPage(data, fallbackSize = 20) {
  if (Array.isArray(data)) {
    return {
      content: data,
      page: 0,
      size: fallbackSize,
      totalElements: data.length,
      totalPages: data.length > 0 ? 1 : 0,
      last: true,
      sort: "",
    };
  }
  if (data && Array.isArray(data.content)) {
    return {
      content: data.content,
      page: data.page ?? 0,
      size: data.size ?? fallbackSize,
      totalElements: data.totalElements ?? data.content.length,
      totalPages: data.totalPages ?? 1,
      last: Boolean(data.last),
      sort: data.sort ?? "",
    };
  }
  return {
    content: [],
    page: 0,
    size: fallbackSize,
    totalElements: 0,
    totalPages: 0,
    last: true,
    sort: "",
  };
}

export async function getPage(url, params = {}, config = {}) {
  const response = await httpClient.get(url, { ...config, params });
  return extractPage(response.data, params.size ?? 20);
}
